var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVirtualCurr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_1848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 0.5C5.42038 0.5 0 5.93806 0 12.6227C0.607187 28.6833 23.5625 28.6793 24.1667 12.6227C24.1667 5.93806 18.7463 0.5 12.0833 0.5ZM13.0903 17.6739V18.6841C13.0852 20.0055 11.0814 20.0045 11.0764 18.6841V17.6739H10.8065C9.73212 17.6739 8.7292 17.094 8.19049 16.1595C7.91156 15.6756 8.0767 15.0584 8.55701 14.7796C9.03934 14.4977 9.65559 14.6654 9.9325 15.1473C10.1127 15.4605 10.447 15.6534 10.8055 15.6534H13.0893C14.0932 15.7191 14.5423 14.0876 13.4477 13.8754L10.3856 13.3632C6.85931 12.7076 7.61854 7.55139 11.0754 7.57159V6.56137C11.0814 5.23999 13.0842 5.241 13.0893 6.56137V7.57159H13.3591C14.4335 7.57159 15.4365 8.15247 15.9752 9.08693C16.2541 9.56982 16.089 10.1871 15.6086 10.4669C15.1253 10.7467 14.5101 10.5811 14.2332 10.0982C14.0529 9.78601 13.7186 9.59306 13.3601 9.59306H11.0764C10.0725 9.52739 9.62437 11.1589 10.7179 11.3711L13.78 11.8832C17.3064 12.5389 16.5471 17.6941 13.0903 17.6739Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_1848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualCurr);
export default __webpack_public_path__ + "static/media/virtual_curr.342565136e7acc03b6b134ce12507be9.svg";
export { ForwardRef as ReactComponent };